__turbopack_context__.v({
  "backButton": "shop-detail-card-module-scss-module__xAjI3W__backButton",
  "fadeInFromRight": "shop-detail-card-module-scss-module__xAjI3W__fadeInFromRight",
  "root": "shop-detail-card-module-scss-module__xAjI3W__root",
});
